/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('mediaInboxAsset', ['AssetService', 'DownloadableMedia', 'Principal', function(AssetService, DownloadableMedia, Principal){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/media-inbox-asset/media-inbox-asset.html',
            scope: {
                content: '=',
                openContent: '&',
                all: '=',
                delete: '&',
                publish: '&',
                markAsNew: '&'
            },
            link: function(scope, element, attrs) {

                var fmt = moment.localeData().longDateFormat('lll');
                var localizedTime = moment.utc(scope.content.publishedDate, fmt).local().format(fmt);
                scope.content.publishedDate = localizedTime;

                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;

                // This is called every time an asset checkbox is toggled
                scope.contentToggled = function() {
                    if(scope.content.selected){
                        scope.all.selectCount++;
                    } else {
                        scope.all.selectCount--;
                    }
                };

                scope.download = function() {
                    var aid = scope.content.xid,
                        cid = scope.content.parent.cid,
                        type = scope.content.type.charAt(0).toUpperCase() + scope.content.type.slice(1);

                    DownloadableMedia.getMedia({
                        aid: aid,
                        cid: cid,
                        type: type
                    }, function (result) {

                        var fileUrl = result.url,
                            fileName = result.name;

                        if(fileUrl) {
                            var linkElement = document.createElement('a');
                            linkElement.setAttribute('href', fileUrl);
                            linkElement.setAttribute("download", fileName);
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });
                            linkElement.dispatchEvent(clickEvent);
                        }

                    });

                    var recordPlayback = new AssetService.RecordPlayback({cid: cid, aid: aid, type: 'D', secondsPlayed: null, mediaDuration: null});
                    recordPlayback.$save();
                };

                scope.checkForEnterKey = function (event, action) {
                    if (event.keyCode === 13) {
                        switch(action){
                            case "publish":
                                scope.publish();
                                break;
                            case "markAsNew":
                                scope.markAsNew();
                                break;
                            case "delete":
                                scope.delete();
                                break;
                            case "download":
                                scope.download();
                        }
                    }
                };
            }
        }

    }]);
